import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../actions/authActions";
import { Grid, Typography, Button } from "@material-ui/core";
import { getPosts } from "../../actions/postActions";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
    marginBottom: 20,
    "& label.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },

  formTitle: {
    fontSize: "2rem",
    fontWeight: 500,
    marginBottom: "1rem",
    fontFamily: "Montserrat, sans-serif",
    color: theme.palette.text.primary,
  },

  formContainer: {
    padding: 20,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    boxShadow: theme.shadows[3],
  },

  loginButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    marginTop: "20px",
    padding: "0.5rem 2rem",
    borderRadius: "0.25rem",
    boxShadow: theme.shadows[2],
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  noScrollbar: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
  },

  registerLink: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const Login = ({ history }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const classes = useStyles();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const errorsFromStore = useSelector((state) => state.errors);
  const loading = useSelector((state) => state.post.loading);

  const handleRegisterPush = () => {
    history.push("/register");
  }

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.push("/");
    }

    if (errorsFromStore) {
      setErrors(errorsFromStore);
    }

    dispatch(getPosts());
  }, [auth.isAuthenticated, errorsFromStore, history, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    name === "login" ? setLogin(value) : setPassword(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const userData = { login, password };
    dispatch(loginUser(userData));
    
  };

  return (
    <Grid container justifyContent="center" style={{ alignItems: "center" }}>
      <Grid item xs={12} sm={8} md={6} lg={4}>
        <div className={classes.formContainer}>
          <form onSubmit={handleSubmit}>
            <Typography className={classes.formTitle}>
              Sign in to get started
            </Typography>

            <TextField
              type="text"
              label="Login"
              className={classes.textField}
              value={login}
              onChange={handleChange}
              name="login"
              helperText={errors.login}
              error={Boolean(errors.login)}
            />

            <TextField
              type="password"
              label="Password"
              className={classes.textField}
              value={password}
              onChange={handleChange}
              name="password"
              helperText={errors.password}
              error={Boolean(errors.password)}
            />

            <Button
              type="submit"
              variant="contained"
              className={classes.loginButton}
            >
              {loading ? 'Redirecting...' : 'Login'}
            </Button>

            <div className="p-4 mb: p-0 mb: pt-4">
              <Typography>
                <Button onClick={handleRegisterPush} className={classes.registerLink}>
                  Not registered? Create account
                </Button>
              </Typography>
            </div>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

export default withRouter(Login);
